/* eslint-disable */
export default {
  to: '発信先',
  enterNameOrNumber: '名前または番号を入力',
} as const;

// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter name or number"@#@
